export const PROJECT_ID = 'wajujogido';
export const MAX_TIMEOUT_LOADABLE = 10000;
export const DEV = 'development';
export const methods = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete',
}

export const COLOR_OPCION = {
  CORRECTO: "correcto",
  ERRONEO: "erroneo",
  NADA: "nada",
  DUDOSA: "dudosa",
  SELECCIONADA: "seleccionada",
};

export const TIPOS_EXAMEN = {
  RAPIDO: "rapido",
  REAL: "real",
  SIMULACRO: "simulacro",
  ERRONEAS: "erroneas",
};

export const PREGUNTA_ANULADA = -1;
export const PREGUNTA_ANULADA_0 = 0;

export const USER_ROL = {
  ACADEMIA: 'academia',
  USER: 'user',
  ADMIN: 'admin',
}


export const filtrosDropDown = [
  {
    name: 'filtro',
    label: "Número pregunta",
    labelToShow: "Nº pregunta",
    value: "NumeroPregunta"
  },
  {
    name: 'filtro',
    label: "Enunciado",
    labelToShow: "Enunciado",
    value: "Enunciado"
  },
  {
    name: 'filtro',
    label: "Materia",
    labelToShow: "Materia",
    value: "Materia"
  },
  {
    name: 'filtro',
    label: "Nombre examen",
    labelToShow: "Examen",
    value: "NombreExamen"
  },
  {
    name: 'filtro',
    label: "Id",
    labelToShow: "Id",
    value: "Id"
  },
  {
    name: 'filtro',
    label: "Correcta",
    labelToShow: "Correcta",
    value: "Correcta"
  },
   {
        name: 'filtro',
        label: "Respuesta 1",
        labelToShow: "Respuesta 1",
        value: "Respuesta 1"
    },
    {
        name: 'filtro',
        label: "Respuesta 2",
        labelToShow: "Respuesta 2",
        value: "Respuesta 2"
    },
    {
        name: 'filtro',
        label: "Respuesta 3",
        labelToShow: "Respuesta 3",
        value: "Respuesta 3"
    },
    {
        name: 'filtro',
        label: "Respuesta 4",
        labelToShow: "Respuesta 4",
        value: "Respuesta 4"
    },
    {
        name: 'filtro',
        label: "Respuesta 5",
        labelToShow: "Respuesta 5",
        value: "Respuesta 5"
    }
]

export const columnasAlias = {
  "Numero pregunta": "Nº pregunta",
  "Enunciado": "Enunciado",
  "Materia": "Materia",
  "Nombre examen": "Examen",
  "IdExamen": "Id examen",
  "Id": "Id",
  "Feedback": "Feedback",
  "Correcta": "Correcta",
  "Respuesta 1": "Resp 1",
  "Respuesta 2": "Resp 2",
  "Respuesta 3": "Resp 3",
  "Respuesta 4": "Resp 4",
  "Respuesta 5": "Resp 5"
};